import { atom } from 'jotai';
import { AppFeatures, ConfigPlan, DetailFeatures } from 'types';

// Default state for plan information
export const planInfoAtom = atom<ConfigPlan>({
  plan: '',
  editable: false,
  basic: false,
  label: '',
  feature: {} as Record<AppFeatures, DetailFeatures>,
});
planInfoAtom.debugLabel = 'planInfoAtom';

// Atom to track loading state for plan information
export const loadingPlanInfoAtom = atom<boolean>(false);
loadingPlanInfoAtom.debugLabel = 'loadingPlanInfoAtom';

// Atom to track error state for plan information
export const errorPlanInfoAtom = atom<boolean>(false);
errorPlanInfoAtom.debugLabel = 'errorPlanInfoAtom';
